import { OptionCard } from '../components/ui.jsx';

/**
 * Every qualifying question (steps three to six) renders through here. The
 * questions themselves live in lib/questions.js, so adding or reordering one
 * is a data change — which is the same bargain the journeys table already
 * makes for landing paths.
 *
 * Selecting an option advances immediately; there is no submit button on these
 * steps in the design, and adding one would put a second click between the
 * customer and the end of the funnel.
 */
export default function QuestionStep({ question, value, onAnswer }) {
  return (
    <div className={`options options--${question.layout}`}>
      {question.options.map((option) => (
        <OptionCard
          key={option.value}
          option={option}
          selected={value === option.value}
          onSelect={(next) => onAnswer(question.key, next)}
        />
      ))}
    </div>
  );
}
